module.exports = __webpack_public_path__ + "static/media/undraw_security_pass.ab9a9131.png";